import PermissionTemplate from "permissions/entities/permission/permission-template";

export default class PermissionTemplateCommand {
  public id?: string;
  public userId?: string;
  public resources?: string;
  public name?: string;
  public description?: string;
  public createdDate?: string;
  public deletedDate?: string;

  constructor(template: PermissionTemplate) {
    this.id = template.id?.toString();
    this.userId = template.userId?.toString();
    this.resources = `[${template.resources?.map(resource => resource.toJSONString()).join(", ")}]`;
    this.name = template.name;
    this.description = template.description;
    this.createdDate = template.createdDate?.toISOString();
    this.deletedDate = template.deletedDate?.toISOString();
  }
}
